import { render, staticRenderFns } from "./ViewSocialWorker.vue?vue&type=template&id=4e5f50d6&scoped=true"
import script from "./ViewSocialWorker.vue?vue&type=script&lang=js"
export * from "./ViewSocialWorker.vue?vue&type=script&lang=js"
import style0 from "./ViewSocialWorker.vue?vue&type=style&index=0&id=4e5f50d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f50d6",
  null
  
)

export default component.exports